<script setup lang="ts">
const emit = defineEmits<{
  navbarClose: []
}>()

const { locales, t } = useI18n()
const switchLocalePath = useSwitchLocalePath()
const route = useRoute()
const shouldShowLanguagePicker = computed(
  () => !route.name?.includes('magazine')
)

const { data: eventListPageData } = useEventListPageStore()

const getLocaleUrl = (localeCode: string): string => {
  if (eventListPageData.value) {
    const { buildLocaleUrl } = useEventListPageLocaleSwitcher(
      eventListPageData.value
    )
    const customUrl = buildLocaleUrl(localeCode)
    if (customUrl) {
      return customUrl
    }
  }

  return switchLocalePath(localeCode)
}
</script>

<template>
  <div class="mt-auto md:hidden">
    <div v-if="shouldShowLanguagePicker">
      <div
        class="mt-2 mb-2 md:border-none md:pb-0 text-gray-800 hover:underline text-base font-bold"
      >
        {{ t('general.language') }}
      </div>
      <NuxtLink
        v-for="locale in locales"
        :key="locale.code"
        class="mr-4"
        :to="getLocaleUrl(locale.code)"
        @click="emit('navbarClose')"
      >
        {{ locale.label }}
      </NuxtLink>
    </div>
  </div>
</template>

<style lang="postcss">
.router-link-active {
  @apply text-primary;
}
</style>
